// extracted by mini-css-extract-plugin
export var body = "_ks-8";
export var button = "_ks-0";
export var closeButton = "_ks-5";
export var content = "_ks-3";
export var empty = "_ks-f";
export var grid = "_ks-c";
export var header = "_ks-4";
export var icon = "_ks-1";
export var option = "_ks-d";
export var optionSelected = "_ks-e";
export var overlay = "_ks-2";
export var searchIcon = "_ks-a";
export var searchInput = "_ks-b";
export var searchWrapper = "_ks-9";
export var title = "_ks-6";
export var visuallyHidden = "_ks-7";